exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@page {\n  size: auto;\n  /* auto is the initial value */\n  /* this affects the margin in the printer settings */\n  margin: 10mm 10mm 10mm 10mm; }\n\n.print-questions h1 {\n  margin-bottom: 0; }\n\n.print-questions .meta {\n  font-size: 1.15em; }\n\n.print-questions .print-question-item h4 {\n  margin-bottom: 0; }\n\n.print-questions .print-question-item p {\n  margin: 0; }\n\n.print-questions .print-question-item + .print-question-item {\n  margin-top: 1em; }\n", ""]);

// exports
